module.exports = __webpack_public_path__ + "media/frontend/components/calculators/images/empty-daf239523fce89b81cd815f091ef8e20.png";